import React from "react";
import { Circle } from "@networkraildigitalfactory/components";
import { CaretRight, Check, DotsThree, Plus } from "phosphor-react";
import styles from "./TableIcons.module.css";

export const CircleCheck = () => {
  return (
    <Circle
      color="#19587B"
      size={28}
      className={styles.check}
      aria-label="completed icon circle"
      role="presentation"
    >
      <Check
        color="#ffffff"
        size={24}
        weight="bold"
        aria-label="completed icon"
        role="presentation"
      />
    </Circle>
  );
};

export const CirclePlus = () => (
  <Circle
    color="#50585C"
    size={28}
    className={styles.plus}
    aria-label="incompleted icon circle"
    role="presentation"
  >
    <Plus color="#ffffff" size={24} weight="bold" aria-label="incompleted icon" role="presentation" />
  </Circle>
);

export const CircleDraft = () => (
  <Circle
    color="#9C107D"
    size={28}
    className={styles.draft}
    aria-label="draft icon circle"
    role="presentation"
  >
    <DotsThree
      color="#ffffff"
      size={24}
      weight="bold"
      aria-label="draft icon"
      role="presentation"
    />
  </Circle>
);

export const CircleGo = () => (
  <Circle
    color="#37519d"
    size={24}
    className={styles.test}
    aria-label="go icon circle"
    role="presentation"
  >
    <CaretRight color="#ffffff" size={20} aria-label="go icon" role="presentation" />
  </Circle>
);
